import { createAction, props } from '@ngrx/store';

export enum EndorsementsSharedActionTypes {
  EndorsementDialogConfirmed = '[Endorsement Dialog] Confirmed',
}

export const EndorsementsSharedActions = {
  endorsementDialogConfirmed: createAction(
    EndorsementsSharedActionTypes.EndorsementDialogConfirmed,
    props<{ endorsement: any }>()
  ),
};
